
import Vue from "vue";
import GenericButton from "@/components/GenericButton.vue";

export default Vue.extend({
  props: {
    errorMessage: {
      type: String,
      default: "Ein Fehler ist aufgetreten.",
    },
  },
  methods: {
    reloadPage(): void {
      window.location.reload();
    },
  },
  components: {
    GenericButton,
  },
});
